import { memo } from 'react';
import { Accordion } from 'react-bootstrap';
import AccordionItem from 'components/AccordionItem';
import styles from './ProductDetails.module.scss';
import StoreSelection from './StoreSelection';

function ProductDetails({ anyActiveVariants = true, details = [], lineage }) {
  const descriptionEventKey = '0';

  return (
    <div id="product-details-wrapper" className="dflex">
      {anyActiveVariants && <StoreSelection />}
      {lineage && (
        <div className={styles.lineage}>
          <p data-value="lineage-text">
            <b>Lineage:</b> {lineage}
          </p>
        </div>
      )}
      <Accordion flush defaultActiveKey={descriptionEventKey}>
        {details.map((detail, idx) => {
          const { header, description } = detail;
          return (
            <AccordionItem
              key={header ?? `detail_section_${idx}`}
              renderBodyAsHtml
              eventKey={idx.toString()}
              header={header}
              body={description}
            />
          );
        })}
      </Accordion>
    </div>
  );
}

export default memo(ProductDetails);
